module.exports = __webpack_public_path__ + "img/service4.28ee9a08.png";